import { render, staticRenderFns } from "./CustomQuestionAnswerQuantity.vue?vue&type=template&id=35bba95d"
import script from "./CustomQuestionAnswerQuantity.vue?vue&type=script&lang=js"
export * from "./CustomQuestionAnswerQuantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports